export const REDUX_CONSTANT = {
    GET_SUBSCRIBER_DATA: 'GET_SUBSCRIBER_DATA',
    GET_ADMIN_SUBSCRIBER_DATA: 'GET_ADMIN_SUBSCRIBER_DATA',
    ADD_SUBSCRIBER_DATA: 'ADD_SUBSCRIBER_DATA',
    FILTER_SUBSCRIBER_DATA_FOR_LSAC: 'FILTER_SUBSCRIBER_DATA_FOR_LSAC',
    FILTER_SUBSCRIBER_DATA_FOR_PREP: 'FILTER_SUBSCRIBER_DATA_FOR_PREP',
    SEARCH_SUBSCRIBER_DATA: 'SEARCH_SUBSCRIBER_DATA',
    RESEND_INVITATION_DATA: 'RESEND_INVITATION_DATA',
    REFUND_STUDENT_DATA: 'REFUND_STUDENT_DATA',
    UPDATE_SUBSCRIBER_DATA: 'UPDATE_SUBSCRIBER_DATA',
    UPDATE_ADD_SUBSCRIBER_BY_DEFAULT: 'UPDATE_ADD_SUBSCRIBER_BY_DEFAULT',
    UPDATE_RESEND_INVITE_BY_DEFAULT: 'UPDATE_RESEND_INVITE_BY_DEFAULT',
    UPDATE_ADD_STUDENT_CONFIRMATION_BY_DEFAULT:
        'UPDATE_ADD_STUDENT_CONFIRMATION_BY_DEFAULT',
    GET_ALL_VENDORS_DATA: 'GET_ALL_VENDORS_DATA',
    REMOVE_ALL_VENDORS_DATA: 'REMOVE_ALL_VENDORS_DATA',
    GET_VENDOR_INFORMATION: 'GET_VENDOR_INFORMATION',
    SET_SELECTED_STUDENT_ITEM: 'SET_SELECTED_STUDENT_ITEM',
    GET_STUDENT_VENDOR_ORDER: 'GET_STUDENT_VENDOR_ORDER',
    GET_STUDENT_TEST_HISTORY_NEW: 'GET_STUDENT_TEST_HISTORY_NEW',
    GET_STUDENT_TEST_HISTORY_MORE: 'GET_STUDENT_TEST_HISTORY_MORE',
    BULK_UPLOAD_STUDENT_DATA: 'BULK_UPLOAD_STUDENT_DATA',
    BULK_UPLOAD_STUDENT_FAIL: 'BULK_UPLOAD_STUDENT_FAIL',
    BULK_UPLOAD_STATUS: 'BULK_UPLOAD_STATUS',
    BULK_UPLOAD_PROCESSED: 'BULK_UPLOAD_PROCESSED',
    TEST_RESULT_PROCESSED: 'TEST_RESULT_PROCESSED',
    ADMIN_TEST_RESULT_PROCESSED: 'ADMIN_TEST_RESULT_PROCESSED',
    STUDENT_DETAIL_RESET: 'STUDENT_DETAIL_RESET',
    ADMIN_STUDENT_DETAIL_RESET: 'ADMIN_STUDENT_DETAIL_RESET',
    TEST_RESULT_PDF: 'TEST_RESULT_PDF',
    ADMIN_TEST_RESULT_PDF: 'ADMIN_TEST_RESULT_PDF',
    SET_RESEND_INVITE_FLAG: 'SET_RESEND_INVITE_FLAG',
    UPGRADE_STUDENT_SUBSCRIPTION_DATA: 'UPGRADE_STUDENT_SUBSCRIPTION_DATA',
    RENEW_STUDENT_DATA: 'RENEW_STUDENT_DATA',
    GET_ADMIN_STUDENT_DETAILS: 'GET_ADMIN_STUDENT_DETAILS',
    GET_ADMIN_STUDENT_ORDER_DETAILS: 'GET_ADMIN_STUDENT_ORDER_DETAILS',
    GET_MORE_ADMIN_STUDENT_ORDER_DETAILS:
        'GET_MORE_ADMIN_STUDENT_ORDER_DETAILS',
    GET_USER_PRODUCTS_DETAILS: 'GET_USER_PRODUCTS_DETAILS',
    ADMIN_STUDENT_ORDER_HOLD_DATA: 'ADMIN_STUDENT_ORDER_HOLD_DATA',
    ADMIN_STUDENT_ORDER_OFF_HOLD_DATA: 'ADMIN_STUDENT_ORDER_OFF_HOLD_DATA',
    ADMIN_STUDENT_ORDER_DETAIL_RESET: 'ADMIN_STUDENT_ORDER_DETAIL_RESET',
    GET_ADMIN_STUDENT_TEST_HISTORY_NEW: 'GET_ADMIN_STUDENT_TEST_HISTORY_NEW',
    GET_ADMIN_STUDENT_TEST_HISTORY_MORE: 'GET_ADMIN_STUDENT_TEST_HISTORY_MORE',
    GET_VENDOR_TEST_MODULES: 'GET_VENDOR_TEST_MODULES',
    FILTER_LIBRARY_DATA: 'FILTER_LIBRARY_DATA',
    SEARCH_LIBRARY_DATA: 'SEARCH_LIBRARY_DATA',
    GET_REPORT_STUDENT_LOG_HISTORY: ' GET_REPORT_STUDENT_LOG_HISTORY',
    ISLOADING: 'ISLOADING',
    GET_VENDOR_TEST_JSON_DATA: 'GET_VENDOR_TEST_JSON_DATA',
    CLEAR_TEST_MODULE_JSON_DATA: 'CLEAR_TEST_MODULE_JSON_DATA',
    GET_VENDOR_REFUND_DATA: 'GET_VENDOR_REFUND_DATA',
    GET_VENDOR_REFUND_PRODUCT_DATA: 'GET_VENDOR_REFUND_PRODUCT_DATA',
    GET_VENDOR_TEST_PDF_DATA: 'GET_VENDOR_TEST_PDF_DATA',
    GET_VENDOR_ALL_TEST_ZIP_DATA: 'GET_VENDOR_ALL_TEST_ZIP_DATA',
    GET_HASH_VALUE: 'GET_HASH_VALUE',
    GET_CONFIGURATION_VALUE: 'GET_CONFIGURATION_VALUE',
    GET_OFFER_DETAILS: 'GET_OFFER_DETAILS',
    GET_VENDOR_OFFERS_LIST: 'GET_VENDOR_OFFERS_LIST',
    CREATE_NEW_OFFER_DATA: 'CREATE_NEW_OFFER_DATA',
    UPDATE_OFFER_DATA: 'UPDATE_OFFER_DATA',
    DOWNLOAD_OFFER_DATA: 'DOWNLOAD_OFFER_DATA',
    CREATE_NEW_VENDOR_DATA: 'CREATE_NEW_VENDOR_DATA',
    ROLES_PERMISSION_INFORMATION: 'ROLES_PERMISSION_INFORMATION',
    PLATFORM_USER_LOGIN: 'PLATFORM_USER_LOGIN',
    UPDATE_ROLES_DATA: 'UPDATE_ROLES_DATA',
    ADMIN_STUDENT_SEARCH_RESET: 'ADMIN_STUDENT_SEARCH_RESET',
    GET_VENDOR_MANAGEMENT_DATA: 'GET_VENDOR_MANAGEMENT_DATA',
    GET_VENDOR_USER_LIST_DATA: 'GET_VENDOR_USER_LIST_DATA',
    GET_CLIENT_SECRET_INTEGRATION_DATA: 'GET_CLIENT_SECRET_INTEGRATION_DATA',
    GET_CLIENT_SECRET_PRODUCTION_DATA: 'GET_CLIENT_SECRET_PRODUCTION_DATA',
    ADD_CLIENT_SECRET_INTEGRATION_DATA: 'ADD_CLIENT_SECRET_INTEGRATION_DATA',
    ADD_CLIENT_SECRET_PRODUCTION_DATA: 'ADD_CLIENT_SECRET_PRODUCTION_DATA',
    GET_ALL_PRODUCTS_DATA: 'GET_ALL_PRODUCTS_DATA',
    ADD_USER_DATA: 'ADD_USER_DATA',
    UPDATE_USER_DATA: 'UPDATE_USER_DATA',
    ALL_USER_ROLES_DATA: 'ALL_USER_ROLES_DATA',
    SUBSCRIBER_HOME_PAGE_RESET: 'SUBSCRIBER_HOME_PAGE_RESET',
    GET_PERMISSION_BASEDON_ROLES: 'GET_PERMISSION_BASEDON_ROLES',
    GET_LIST_OF_LAWREADY_STUDENTS: 'GET_LIST_OF_LAWREADY_STUDENTS',
    ADD_LAWREADY_SUBSCRIBER_DATA: 'ADD_LAWREADY_SUBSCRIBER_DATA',
    LAWREADY_RESEND_INVITATION_DATA: 'LAWREADY_RESEND_INVITATION_DATA',
    GET_REFRESH_SUBSCRIPTION_DATA: 'GET_REFRESH_SUBSCRIPTION_DATA',
    PLATFORM_USER_INVITATION_DATA: 'PLATFORM_USER_INVITATION_DATA',
    LOGOUT_RESET: 'LOGOUT_RESET',
    DEACTIVATE_USER_DATA: 'DEACTIVATE_USER_DATA',
    SET_NUMBER_OF_OFFER_CODE_CREATED: 'SET_NUMBER_OF_OFFER_CODE_CREATED',
    UPDATE_VENDOR_INFO_DATA: 'UPDATE_VENDOR_INFO_DATA',
    IS_VENDOR_ROLE_UPDATED_FROM_SERVER: 'IS_VENDOR_ROLE_UPDATED_FROM_SERVER',
    RESET_VENDOR_DATA: 'RESET_VENDOR_DATA',
    DELETE_CLIENT_SECRET_DATA: 'DELETE_CLIENT_SECRET_DATA',
    CLEAR_CLIENT_SECRET_RESPONSES: 'CLEAR_CLIENT_SECRET_RESPONSES',
    REMOVE_CLIENT_SECRET_FROM_STATE: 'REMOVE_CLIENT_SECRET_FROM_STATE',
    LICENSEE_MARK_PDF_DATA: 'LICENSEE_MARK_PDF_DATA',
    LICENSEE_MARK_ZIP_DATA: 'LICENSEE_MARK_ZIP_DATA',
    CLEAR_LICENSEE_MARK_DATA: 'CLEAR_LICENSEE_MARK_DATA',
    AUTH: {
        LOGIN_SUCCESS: 'LOGIN_SUCCESS',
        UPDATE_ACQUIRED_VENDOR_ROLE: 'UPDATE_ACQUIRED_VENDOR_ROLE',
        STATE: {
            UNAUTHENTICATED: 'UNAUTHENTICATED',
            INITIALIZING: 'INITIALIZING',
            INITIALIZED: 'INITIALIZED',
            ACQUIRED_ID_TOKEN_SUCCESS: 'ACQUIRED_ID_TOKEN_SUCCESS',
            LOGIN_SUCCESS: 'LOGIN_SUCCESS',
            LOGIN_ERROR: 'LOGIN_ERROR',
            ACQUIRED_ID_TOKEN_ERROR: 'ACQUIRED_ID_TOKEN_ERROR',
            LOGOUT_SUCCESS: 'LOGOUT_SUCCESS'
        }
    },
    services: {
        vendorService: 'vendorService',
        adminService: 'adminService',
        offersService: 'offersService',
        configurationService: 'configurationService'
    }
};

export const SUBSCRIBER = {
    myStudents: 'My Students',
    allStudents: 'All Students',
    student: 'Student',
    subscription: 'Subscription',
    addStudent: 'Add Student',
    updateStudent: 'Update Student',
    renewStudent: 'Renew Student',
    pausedItem: '(PAUSED)',
    noCoachesFound: 'No Coaches Found',
    noOrdersFound: 'No Orders Found',
    noDataFound: 'No Data Found',
    success: 'success',
    error: 'error',
    since: 'Since',
    FreeWaiver: 'Free Waiver:',
    PlusProgram: 'Plus Program:',
    studentAddingError: 'Student Adding Error',
    pdfDownloadError: 'Something went wrong while downloading the record.',
    dataFetchError: 'Data fetch error for this student id',
    studentAddedSuccessfully: 'Student added successfully',
    studentRenewedSuccessfully: 'Student record updated successfully',
    studentEmailUpdatedSuccessfully: 'Student email updated successfully',
    invitationSentSuccess: 'Invitation Sent Successfully',
    invitationSendError: 'Invitation Send Error',
    invitationSendErrorCode400:
        'We are Sorry, An error occurred while processing your request. Please try again later. If the issue continues, please contact our support team for assistance. Thank you for your patience.',
    subscriberUpdateError: 'Updating Student Information failed',
    browseFile: 'Browse',
    uploadedFile: 'Uploaded File',
    browseFileToUpload: 'Browse the file to upload',
    noFileUploaded: 'No File Uploaded',
    fileCountError: 'Records count must be less than 1000',
    RefundSuccess: 'Refund Successful',
    RefundError: 'Refund Error',
    markAsRefund: 'Mark As Refund',
    fullOrderRefund: 'Full Order Refund',
    lsacPremiumSubscription: 'LSAC-Premium Subscription',
    lsacOneyearCoachingLicense: 'LSAC-1yr Coaching License',
    refunded: 'Refunded',
    refreshSubscription: 'Refresh Subscription',
    studentDataUpdatedSuccessfully: 'Student data updated successfully',
    refreshSubscriptionError: 'Refresh Subscription Error',
    fileName: 'File Name',
    uploadDate: 'Upload Date',
    processed: 'Processed',
    notProcessed: 'Not Processed',
    processing: 'Processing',
    processingCompleted: 'Processing Completed',
    processingFailed: 'Processing Failed',
    successfullyUploaded: 'Successfully Uploaded',
    outOf: ' out of ',
    lNo: 'L#',
    orders: 'Orders',
    coaching: 'Coaching',
    products: 'Products',
    history: 'History',
    orderId: 'Order Id',
    orderDate: 'Order Date',
    status: 'Status',
    refCode: 'Reference Code',
    refCodeShort: 'Ref. Code',
    method: 'Method',
    decision: 'Decision',
    reason: 'Reason',
    tax: 'Tax',
    view: 'View',
    all: 'All',
    value: 'Value',
    filters: 'Filters:',
    vendorName: 'Vendor Name',
    total: 'Total',
    hold: 'Hold',
    releaseHold: 'Release Hold',
    noUploadedRecords: 'No Records Uploaded',
    openLink: 'Open link in a new tab.',
    downloadLink: 'Download the file.',
    confirmResendInvite: 'Resend Invite Confirmation !',
    addStudentConfirmation: 'Add Student Confirmation!',
    renewStudentConfirmation: 'Renew Student Confirmation',
    updateStudentConfirmation: 'Update Student Confirmation!',
    updateSubscriptionConfirmation: 'Update Subscription Confirmation!',
    upgradeStudentToPrepPlus: 'Upgrade Student to LawHub Advantage!',
    noVendorRoles: 'No Vendor Roles!',
    noVendorRolesMessage1: 'Your email ID',
    noVendorRolesMessage2: ' has not been assigned to any role.',
    noVendorRolesMessage3: 'Please contact LSAC to resolve this issue.',
    adminStudentOrderHoldSuccessfully: 'Order hold successfully',
    theUserOrderReleasedSuccessfully: 'The user order released successfully',
    orderHoldError: 'Order Hold Error',
    orderOffHoldError: 'Order Off Hold Error',
    productID: 'Product ID',
    activationDate: 'Activation Date',
    expirationDate: 'Expiration Date',
    purchaseStatus: 'Purchase Status',
    fee: 'Fee',

    upload_states: {
        None: 'None',
        Queued: 'Queued',
        InProgress: 'InProgress',
        Completed: 'Completed',
        Failed: 'Failed'
    },
    uploadError: 'Bulk Upload Failed',
    uploadFileHeading: 'Upload File: Bulk Student Record',
    details: {
        detailHeader: ' - Details',
        dateRange: 'Pick Date(s)',
        pickDate: 'Pick Date(s)',
        today: 'Today',
        testName: 'Test Name',
        examDate: 'Date',
        startDate: 'Start Date',
        examMode: 'Mode',
        rawScore: 'Raw Score',
        report: 'Report',
        deeplink: 'Deep Link',
        coachingId: 'Coaching Id : ',
        linkStatus: 'Link Status : ',
        scaledScore: 'Scaled Score',
        status: 'Status',
        completed: 'Completed',
        inProgress: 'In Progress'
    },
    tabs: {
        ordersTitle: 'Orders',
        log: 'Log',
        testHistory: 'Test History',
        loadMore: 'Load More',
        informationTitle: 'INFORMATION'
    },
    dropdown: {
        remove: 'Remove student',
        upgrade: 'Upgrade student',
        changeEmail: 'Change email address'
    },
    updateEmail: 'Update Email!',
    pleaseConfirmThatYouWishToUpdateEmail:
        'Please confirm that you wish to update this email id',
    refine: 'Refine',
    subscriberUpgradeError: 'Upgrading Student Failed. Please try again!',
    subscriberUpgradeSuccess: 'Student upgrade request successfully submitted!',
    tooltip: {
        upgrade: 'Upgrade to LawHub Advantage',
        upgradeInProgress: 'Upgrade in progress ',
        resend: 'Resend invitation',
        expiry1: ' expires in the next ',
        days: ' day(s).',
        expiry2: ' Please click here to renew.',
        expires: ' expires',
        today: ' today.',
        tomorrow: ' tomorrow.',
        expired: ' has been expired.'
    },
    fullOrderRefundedError: 'Error in Full Order Refunded',
    productOrderRefundedError: 'Error in Product Order Refunded',
    fullOrderRefunded: 'Full Order Refunded',
    productOrderRefunded: 'Product Order Refunded',
    studentTestReport: 'Student Test Report'
};

export const CONTENT_LIBRARY = {
    title: 'Content Library',
    content: 'content',
    contentAll: 'All',
    contentLSAC: 'Lsac',
    contentMy: 'My Content',
    administered: 'Administered',
    addTags: 'Add tags',
    copyLink: 'Copy test link',
    copyDeepLink: 'Copy Deep link',
    selfPaceMode: 'Self-Paced Mode',
    examMainMode: 'Exam Mode',
    exportPDF: 'Export to PDF',
    noCourseFound: 'No Course Found',
    FILTER_TYPE_TOTAL: 'totalData',
    FILTER_TYPE_LSAC: 'lsacData',
    FILTER_TYPE_MY: 'mylData',
    name: 'Name',
    actions: 'Actions',
    pdf: 'PDF',
    json: 'JSON',
    searchTest: 'Search a Test',
    descriptionHeader: 'Description : ',
    adminDateHeader: 'Administered in : ',
    noTestsFound: 'No Tests Found',
    linkCopiedToClipboard: 'Link copied to clipboard!',
    linkCopyError: 'Link Copy Error!',
    tests: 'tests',
    error: 'error',
    pdfDownloadError: 'Something went wrong while downloading the record.'
};

export const COMMON = {
    done: 'Done',
    disabled: 'Disabled',
    enabled: 'Enabled',
    flagVendor: 'Flag Vendor',
    contentLicense:
        'When enabled the Vendor’s name will be displayed on LSAT Content licensee',
    clear: 'Clear',
    home: 'Home',
    end: 'End',
    students: 'students',
    noStudentsFound: 'No Students Found',
    actions: 'Actions',
    resendInvite: 'Resend Invite',
    goback: 'Go back',
    lsacLogoAlt: 'Law School Admission Council',
    pagination: 'Pagination',
    searchOption: 'Search Options',
    search: 'Search',
    searchStudents: 'Search Students',
    studentName: 'Name',
    selectProducts: 'Select Product',
    subscriptionPeriod: 'Subscription Period',
    acquisitionPeriod: 'Acquisition Period',
    accountCreation: 'Account Creation Date',
    accountCreated: 'Account Created',
    userName: 'User Name',
    nameEmail: 'Name & Email',
    registrationDate: 'Registration Date',
    ActionsMenu: 'Actions DropdownMenu',
    stop: 'Stop',
    start: 'Start',
    yes: 'Yes',
    no: 'No',
    descending: 'descending',
    downloadCsvFile: 'download CSV File',
    ascending: 'ascending',
    dateCreated: 'Date Created',
    linkedDate: 'Linked Date',
    pause: 'Pause',
    prep: 'Prep',
    confirm: 'Confirm',
    examDays: 'Exam-365-Days',
    examSection: 'Exam-365-3Sections',
    maxTextLength: 22,
    maxEmailLength: 44,
    resume: 'Resume',
    previousPage: 'Previous Page',
    nextPage: 'Next Page',
    nextFivePages: 'Next 5 Pages',
    PreviousFivePages: 'Previous 5 Pages',
    disabledPreviousPage: 'Disabled Previous Page',
    disabledNextPage: 'Disabled Next Page',
    coachingStatus: 'Coaching Status',
    coachingPeriod: 'Coaching Period',
    coachingStartDate: 'Coaching Start Date',
    prepStatus: 'Redemption Status',
    lsacSubscription: 'LawHub Advantage Period',
    expirationDate: 'LawHub Advantage EXPIRATION',
    products: 'Product(s)',
    prepPlusSubscription: 'LawHub Advantage subscription',
    linkStatusFilter: 'linkStatusFilter',
    prepFilter: 'prepFilter',
    SET_PAGE: 'SET_PAGE',
    studentEmailId: 'Student Email',
    name: 'Student Name & Email',
    subscriptionType: 'Subscription Type',
    loginDateTime: 'Logged in Date & Time',
    linked: 'Link Status',
    mmddyyDateFormat: 'MM/DD/YYYY',
    pageNotFound: 'Page Not Found',
    unathorisedPage: 'You are not authorized to access this page',
    returnToHomePage: 'Return to Home Page',
    exclaimation: '!',
    questionMark: '?',
    cancel: 'Cancel',
    close: 'Close',
    arrow: '',
    arrowLeft: 'ArrowLeft',
    arrowRight: 'ArrowRight',
    enter: 'Enter',
    plus: 'Plus',
    ok: 'Ok',
    selectDate: 'Select Date',
    dateInput: 'Date',
    searchByName: 'Search by Name',
    prepPlus: 'LawHub Advantage',
    choose: 'Pick',
    date: 'date',
    dateTime: 'Date & Time',
    chooseDate: 'Choose',
    launchMenu: 'Launch student menu',
    email: 'Email',
    calendar: {
        dayTitle: {
            sunday: 'Su',
            monday: 'Mo',
            tueday: 'Tu',
            wednesday: 'We',
            thursday: 'Th',
            friday: 'Fr',
            saturday: 'Sa'
        }
    },
    success: 'success',
    error: 'error',
    userIcon: 'User Icon',
    userThumbnail: 'User Thumbnail',
    testLogo: 'Test Logo',
    pdfDownload: 'PDF Download',
    jsonDownload: 'JSON Download',
    copyDeepLink: 'Copy Deep Link',
    noOption: 'No option',
    allPdf: 'All Official LSAT Prep Test PDFs',
    allJson: 'All Official LSAT Prep Test JSON',
    allDownload: 'Download: All',
    searchByFirstName: 'Search by first name',
    searchByLastName: 'Search by last name',
    searchByUserName: 'Search by user name',
    searchByEmail: 'Search by email',
    vendorType: 'Vendor Type',
    vendors: 'Vendors',
    arrowKeyDown: '40',
    arrowKeyUp: '38',
    percentage: '%',
    all: 'All',
    users: 'USERS',
    resend: 'Resend',
    somethingWentWrong: 'Something Went Wrong!',
    apiOrServerErrorHtml: `<p id="apiError">It seems there was an <b>API or an internal server issue.</b> Please retry once again or If the problem persist please contact LSAC for a resolution.</p> <p><span id="lsacContactInfo">Please email our technical support team at </span> <a aria-describedby="apiError lsacContactInfo" href=\"mailto:licensingsupport@lsac.org\">licensingsupport@lsac.org</a></p>`,
    lsatAdmin: 'LSAT-Admin',
    contentBuilder: 'contentBuilder',
    accepted: 'accepted',
    errorHeading:
        'Please provide all information, following fields were invalid or empty:',
    marketplaceFlagged: 'Displayed on Marketplace',
    question: 'question',
    subType: 'subType',
    difficulty: 'difficulty',
    totalTimeTaken: 'totalTimeTaken',
    upArrow: 'up-arrow',
    downArrow: 'down-arrow',
    ascending: 'ascending',
    descending: 'descending',
    commonServerError: 'Something went wrong! Please retry after sometime',
    evaluation: 'evaluation',
    adminLowerCase: 'admin',
    admin: 'ADMIN',
    one: '1',
    two: '2',
    three: '3',
    OfficialLSAC: 'OfficialLSAC',
    lsacPlusProgram: 'LSAC-PLUS Program',
    lsacAdmin: 'LSAC-Admin',
    partnerUser: 'Partner-User',
    user: 'user',
    vendor: 'vendor',
    errorCodes: [400, 401, 403, 404, 408, 429, 500, 502, 503, 504],
    enterDescription: 'Enter Description',
    clientSecretPageNumber: 1,
    retry: 'Retry',
    APIOrServerError: 'API or Server Error!',
    lsacContactDetails: 'licensingsupport@lsac.org',
    notLinked: 'Not Linked',
    okay: 'Okay'
};

export const VALIDATION_MESSAGE = {
    emailLoginValidation: 'Please enter your email id.',
    inValidEmail: 'Please enter valid email id.',
    passwordValidation: 'Please enter your password',
    invalidUsernameOrPassword: 'Invalid username or password',
    firstName: 'Please enter a valid first name.',
    lastName: 'Please enter a valid last name.',
    email: 'Please enter a valid email address.',
    startDate: 'Please enter a valid start date',
    endDate: 'Please enter a valid end date',
    type: 'Please select the invitation type.',
    renewType: 'Please select the renew type.',
    empty: 'Input some value to search',
    selectField: 'Search with atleast one field value entered',
    offerName: 'Please enter a valid offer name.',
    number: 'Please enter a valid number.',
    vendorName: 'Please enter a valid vendor name.',
    vendorId: 'Please enter a valid vendor ID.',
    userName: 'Please enter a valid user name.',
    availableProducts: 'Please select product type(s).',
    codeExpDate: 'Please enter a valid code expiration date and time.',
    productAssociatedValue: 'Please select product(s).',
    updateOfferDataMessage: 'Please update offer name or offer codes',
    assignedRole: 'Please select role(s).',
    updateUserErrorMessage: 'Please update user name or roles',
    vendorTypeErrorMessage: 'Please select vendor type',
    vendorProductandRateErrorMessage:
        'Please fill product associated and its respective rate of product',
    apiAccessErrorMessage: 'Please select environment(s).',
    resourceAvailableErrorMessage:
        'Please select a resource available to vendor.',
    qtyOfferCodesErrorMessage: 'Please enter offer codes quantity',
    offerCodesForProductErrorMessage:
        'Please select associated product(s) for offer code generation',
    updateVendorErrorMessage: 'Please update vendor data',
    invalidImageType: 'Please enter a valid image format',
    invalidImageSize: 'Please enter image with size below 1MB',
    updateData: 'Please enter new data to update student record',
    updateSubscriberEmailMessage: 'Please update email id',
    searchbyFirstName: 'Please enter valid first name',
    searchbyLastName: 'Please enter valid last name',
    searchbyUserName: 'Please enter valid user name'
};

export const ADD_STUDENT = {
    firstName: 'First Name',
    lastName: 'Last Name',
    address: 'Address',
    type: 'Type',
    enterYourFirstName: 'Enter your first name',
    enterYourLastName: 'Enter your last name',
    enterYourEmailAddress: 'Enter your email address',
    pleaseConfirmThatYouWishToAdd:
        'Please confirm that you wish to add the following details as a student and send them an invitation at the below mentioned email.',
    pleaseConfirmAdd: 'Please confirm that you wish to add',
    asAStudentAndSendThemAnInvitationEmailAt:
        'as a student and send them an invitation email at',
    pleaseConfirmThatYouWishToResendAnInvitationEmailTo:
        'Please confirm that you wish to resend an invitation email to ',
    invitationTypeBoughtLsatTitle: 'Bought LawHub Advantage',
    invitationTypeBoughtLsatMessage:
        '(Student signed up for a course using LawHub Advantage content and purchased a subscription from us.) – $',
    invitationTypeLinkPrepTitle: 'Link to LawHub Advantage Subscription',
    invitationTypeLinkPrepMessage:
        '(Student signed up for a course using LawHub Advantage content and will provide their own subscription.) - $',
    invitationTypeLinkLsatTitle: 'Link to Official LSAT Prep Subscription',
    invitationTypeLinkLsatMessage:
        '(Student signed up for a course using Official LSAT Prep content only.) - $',
    invitationTypeFeeWaiverTitle: 'Fee Waiver Subscription',
    invitationTypeFeeWaiverMessage:
        '(Student is granted subscription via Fee Waiver)',
    pleaseConfirmThatYouWishToUpdateSubscriptionFor:
        'Please confirm that you wish to update subscription for',
    pleaseConfirmThatYouWishtoUpgrade:
        'Please confirm that you wish to upgrade',
    fromPrepToThePrepPlusSubscription:
        ' from Prep to LawHub Advantage subscription.',
    onceConfirmed: '  Once confirmed',
    monthlyInvoice1:
        '  will be immediately upgraded and you will subsequently incur a charge of $',
    monthlyInvoice2: ' for this subscription on your next monthly invoice.',
    invitationTypePlusProgram: 'Invite student to LSAC PLUS Program',
    invitationTypeLawReadyProgram: 'Invite student to Law Ready Program',
    updateStudentMessage:
        'Please confirm that you wish to update the following details as a user.'
};

export const BULK_UPLOAD = {
    uploadFile: 'Upload File'
};

export const SCREEN_READER = {
    menu: {
        logout: 'Press enter to log out of the application.',
        offers: 'Press enter to navigate to Offers page',
        myStudents: 'Press enter to navigate to My Students page'
    },
    addStudent: {
        invitationType:
            'Press space to select subscription type for new student from following list items,'
    },
    resendInvite: {
        updateEmailInfo: 'Press enter to update the email ID.'
    },
    subscriber: {
        tableIntroduction: `Student's Official LSAT Prep status.`,
        searchNameEmail: `Search by student name or email address`,
        searchDetails: `Type student name or email address in search box and hit enter key to reveal results.`,
        refreshEnter: ', Press enter to resend invite for ',
        descendingOrder: 'sorted by descending order',
        ascendingOrder: 'sorted by ascending order',
        goback: 'Press to navigate to my students page',
        gobackOffers: 'Press to navigate to offers page',
        studentDetails: 'Press enter to see the details',
        upgrade:
            ', click Prep to invite student for updating subscription type.'
    },
    renewStudent: {
        renewType:
            'Press space to select renew type for student from following list items,'
    },
    adminDetails: {
        descendingOrder: 'sorted by descending',
        ascendingOrder: 'sorted by ascending'
    },
    reporting: {
        searchDetails: `For the 'search' textbox below, the results will be revealed on screen as you type the first three letters of the test name into the textbox.`,
        searchTestName: `Search by test name`,
        pressEnterKeyToSort: 'Press enter key to sort',
        vendorIdSortedByDescendingOrder:
            'Vendor I d sorted by descending order',
        vendorIdSortedByAscendingOrder: 'Vendor I d sorted by ascending order',
        loginDateAndTimeSortedByDescendingOrder:
            'Login date and time sorted by descending order',
        loginDateAndTimeSortedByAscendingOrder:
            'Login date and time sorted by ascending order',
        searchByEmailId: 'Search by Email Id'
    }
};

export const TEST_HISTORY = {
    rawTotalScore: 'Raw Test Score',
    rawSectionScore: 'Raw Section Score',
    testTime: 'Test Time',
    sectionTime: 'Section Time',
    correct: 'Correct',
    emptyResponse: 'Empty',
    mode: 'Mode: ',
    date: 'Date: ',
    separator: ' | ',
    scoreSeparator: ' / ',
    print: 'Print',
    examMode: 'Exam',
    sectionIndex: 'Section ',
    selfPaceMode: 'Self-Paced',
    questionHeader: '#',
    response: 'Response',
    evaluation: 'Evaluation',
    answer: 'Answer',
    subType: 'SubType',
    difficulty: 'Difficulty',
    totalQuestionTime: 'Total Question Time'
};

export const RENEW_STUDENT = {
    studentRenewedSuccessfully:
        'Student has been provided a renewal/extension!',
    studentRenewingError: 'Student Renwing Error',
    firstName: 'First Name',
    lastName: 'Last Name',
    address: 'Address',
    type: 'Type',
    pleaseConfirmThatYouWishToRenew: 'Please confirm that you wish to renew',
    asAStudent: 'as a student',
    andSendThemAnRenewalEmailAt: 'and send them a renewal email at',
    renewTypeBothTitle:
        "Renew both the student's LawHub Advantage & my coaching period for another 12 months - $",
    renewTypeOnlyPrepTitle:
        "Renew ONLY the student's LawHub Advantage for another 12 months - $",
    renewTypeOnlyCoachingTitle:
        'Renew ONLY my Coaching period for another 12 months - $'
};

export const ADMIN_DETAILS = {
    productFilterTitle: 'Product Type',
    pleaseConfirmThatYouWishToPlaceThisOrderOnHold:
        'Please confirm that you wish to place this order on hold or cancel to return.',
    pleaseConfirmThatYouWishToReleaseTheHoldOnThisOrder:
        'Please confirm that you wish to release the hold on this order or cancel to return.',
    holdOrderConfirmation: 'Hold Order Confirmation',
    releaseHoldConfirmation: 'Release Hold Confirmation',
    orderDetailsHeaders: {
        title: 'Order Details - #',
        firstName: 'First Name',
        fullName: 'Full Name',
        lastName: 'Last Name',
        city: 'City',
        state: 'State',
        postalCode: 'Postal Code',
        country: 'Country',
        address: 'Address',
        productList: 'Product List',
        cityTax: 'City Tax Amount',
        stateTax: 'State Tax Amount',
        countryTax: 'Country Tax Amount',
        authCode: 'Authorization Code',
        reconciliationId: 'Reconciliation Id',
        requestId: 'Request Id',
        referenceCode: 'Reference Code',
        decision: 'Decision',
        reasonCode: 'Reason Code',
        orderSummary: 'Order Summary',
        items: 'Items',
        cityTax: 'City Tax',
        countryTax: 'Country Tax',
        stateTax: 'State Tax',
        zip: 'Zip',
        transacDet: 'Transaction Details'
    },
    itemDetailsHeaders: {
        title: 'Item Details',
        prodId: 'Product Id',
        term: 'Term',
        termFrequency: 'Term Frequency',
        price: 'Price',
        owner: 'Owner',
        prodType: 'Product Type',
        prodStatus: 'Product Status',
        product: 'Product'
    },
    coachDetailHeaders: {
        vendorId: 'Vendor Id',
        coachingId: 'Coaching Id',
        coachingExpDate: 'Coaching Expiry Date',
        redemptionStatus: 'Redemption Status',
        dataSharing: 'Data Sharing'
    }
};

export const REPORTS = {
    linkedStatus: 'Linked Status',
    logs: 'Logs',
    noLogsFound: 'No Logs Found'
};

export const OFFERS = {
    OffersTitle: 'Offers',
    codeExpirationDate: 'Code Expiration Date',
    codeExpirationDateTime: 'Code Expiration Date & Time',
    createNewOffer: 'Create New Offer',
    enterOfferName: 'Enter Offer Name',
    addOffer: 'Add Offer',
    addOfferCode: 'Add an Offer Code',
    offerDetails: 'OFFER - DETAILS',
    createdOn: 'Created On :',
    numberOfferCodes: 'Number of Offer Codes :',
    productsAssociatedAndStartDate: 'Products Associated and Start Date :',
    download: 'Download',
    downloadOfferCodes: 'Download Offer Codes',
    redeemed: 'Redeemed',
    noOfOfferCodes: 'Number Of Offer Codes',
    enterNoOfOfferCodes: 'Enter/select number of codes',
    selectExpirationDate: 'Select expiration date and time',
    productsAssociated: 'Products Associated',
    perOfferCodeRedeemed: '1 Day Event : $10 (Per Offer Code Redeemed)',
    productStartDate: 'Product Start Date',
    productStartDateTime: 'Product Start Date & Time',
    codeExpirationTime: 'Choose code expiration time',
    selectStartDate: 'Select start date and time',
    createOfferConfirmation: 'Create Offer Confirmation!',
    productAssociatedList: 'Product Associated List',
    timeExpirationDropdown: 'Time Expiration Dropdown opened',
    searchByOfferName: 'search by offer name',
    pleaseConfirmWish:
        'Please confirm that you wish to update the following details as an offer:',
    noOffersFound: 'No Offers Found',
    selectTypeOfProductAssociated: 'Select type of products associated',
    offerCreatedSuccessfully: 'Offer Created Successfully',
    createOfferError: 'Create Offer Error',
    offerUpdatedSuccessfully: 'Offer Updated Successfully',
    updateOffer: 'Update Offer',
    updateOfferConfirmation: 'Update Offer Confirmation!',
    updateOfferError: 'Update Offer Error',
    offerTableHeader: {
        offerName: 'Offer Name',
        codesCreated: 'CODES CREATED',
        codesRedeemed: 'CODES REDEEMED',
        actions: 'ACTIONS',
        offerCode: 'Offer Codes ',
        redeemedDate: 'Redeemed Date',
        exDateCode: 'Ex Date of Code',
        expriationDate: 'Expiration Date'
    },
    offersPaginationTitle: 'offers',
    offerDownloadError: 'Offer Downloading Error',
    offerCodeGenerationError: 'Offer Codes Generation is in Progress',
    offerExpired: 'This offer has expired !',
    expired: 'Disabled Offer Expired'
};

export const VENDOR = {
    vendors: 'Vendors',
    addVendor: 'Add Vendor',
    updateVendor: 'Update Vendor',
    vendorName: 'Vendor Name',
    vendorId: 'Vendor ID',
    vendorType: 'Vendor Type',
    vendorCreationDate: 'VENDOR CREATION DATE',
    actions: 'ACTIONS',
    edit: 'Edit',
    editVendorIdentity: 'Edit Vendor Identity',
    editConfiguration: 'Edit Configuration',
    editPermission: 'Edit Permission',
    forProfit: 'For Profit',
    nonProfit: 'Non Profit',
    profit: 'Profit',
    deactivate: 'Deactivate',
    noVendorsFound: 'No Vendors Found',
    oneYearPrepPlus: '1 yr LawHub Advantage: $40',
    oneDayEvent: '1 Day Event:',
    rateOfProduct: 'Rate of Product',
    typeProductRate: 'Type Product Rate',
    previous: 'Previous',
    next: 'Next',
    continue: 'Continue',
    vendorIdentity: 'Vendor Identity',
    inProgress: 'In Progress',
    progress: 'Progress',
    configuration: 'Configuration',
    completed: 'Completed',
    permissions: 'Permissions',
    marketplaceInfo: 'Marketplace Info',
    pending: 'Pending',
    pendingStep: 'PendingStep',
    inProgressStep: 'InProgressStep',
    completedStep: 'CompletedStep',
    none: 'None',
    qtyOfferCodes: 'Quantity Of Offer Codes Allowed',
    qtyOfferCodesShort: 'Qty. of Offer Codes Allowed',
    enableOfferCode:
        'Enable Offer Code Generation for the following products associated',
    environmentVendor:
        'in which environment does this vendor have an API access',
    resourceAvailableVendor: 'Resource Available to Vendor',
    licenseeMark: 'Licensee Mark',
    bulkUpload: 'Bulk Upload',
    resourceOptions: ['Licensee Mark', 'Bulk Upload', 'None'],
    integration: 'Integration',
    production: 'Production',
    both: 'Both',
    enterVendorName: 'Enter Vendor Name',
    enterVendorId: 'Enter Vendor ID',
    selectTypeOfVendor: 'Select Type of Vendor',
    vendorIdUnique: 'Vendor ID is unique and must contain the following:',
    startingUppercase:
        'Starting with 3 Uppercase letters representing the vendor name',
    followedCalendar:
        'Followed by the calender year in which the vendor is created',
    dateOfCreation: 'Date of Creation',
    addVendorConfirmation: 'Add Vendor Confirmation!',
    updateVendorConfirmation: 'Update Vendor Confirmation!',
    pleaseConfirmVendor:
        'Please confirm that you wish to add the following details of a vendor:',
    pleaseUpdateConfirmVendor:
        'Please confirm that you wish to update the following details of a vendor:',
    enableGenerationFor: 'Enable Offer Code Generation for: ',
    apiAccessEnabledFor: 'API Access Enabled for : ',
    resourceAvailableVendorFor: 'Resource Available to Vendor : ',
    offerCodesAllowed: 'Offer Codes Allowed',
    vendorDetails: 'Vendor - Details',
    lsacVendor: 'LSAC Vendor',
    createdOn: 'Created On',
    productAssociatedRate: 'Product Associated and Rate',
    apiAccessEnabled: 'API Access enabled for',
    offerCodeGenerationEnabled: 'Offer Code Generation enabled for',
    editVendorDetails: 'Edit Vendor Details',
    addUser: 'Add User',
    updateUser: 'Update User',
    userNameEmail: 'User Name/Email',
    userRole: 'User Role',
    userCreationDate: 'User Creation Date',
    invitePending: 'Invite pending',
    professorMarketing: 'Professor Marketing',
    sales: 'Sales',
    reports: 'Reports',
    userType: 'User Type',
    assignedRole: 'Assigned Role',
    selectTypeOfUser: 'Select the type of User',
    selectAssignedRoleUser: 'Select the assigned role for the user',
    internal: 'Internal',
    external: 'External',
    addUserConfirmation: 'Add User Confirmation !',
    updateUserConfirmation: 'Update User Confirmation !',
    pleaseConfirmWishMentioned:
        'Please confirm that you wish to add the following details as a user and send them an invitation email at the below mentioned address:',
    pleaseConfirmWishMentionedForUpdate:
        'Please confirm that you wish to update the following details as a user and send them an invitation email at the below mentioned address:',
    userNameSpace: 'User Name',
    vendorCreatedSuccessfully: 'Vendor Created Successfully',
    vendorUpdatedSuccessfully: 'Vendor Updated Successfully!',
    addVendorError: 'Add Vendor Error',
    saveAndReturn: 'Save & Return',
    somethingWentWrong: 'Something went wrong!',
    vendorAddedSuccessMessage:
        'The Vendor {vendorName} was added successfully! The details are mentioned below:',
    vendorUpdatedSuccessMessage: 'The vendor was updated successfully!',
    unknownErrorOccurred:
        'An error occurred when creating the vendor. Please try again.',
    userCreatedSuccessfully: 'User Created Successfully',
    userUpdatedSuccessfully: 'User Updated Successfully',
    userDeactivatedSuccessfully: 'User Deactivated Successfully',
    addUserError: 'Add User Error',
    updateUserError: 'Update User Error',
    deactivateUserError: 'Deactivate User Error',
    updateVendorError: 'Update Vendor Error',
    universityLsac: ' - The University of LSAC; ',
    onlyDate: ' - 09/28/2021; ',
    idVendor: ' - TUL2021',
    ex: 'Ex: ',
    previouSlide: 'Previous Slide',
    nextSlide: 'Next Slide',
    vendorIdentityPage: 1,
    configurationPage: 2,
    permissionsPage: 3,
    marketplaceInfoPage: 4,
    searchVendor: 'Search Vendors',
    searchUser: 'Search Users',
    noUsersFound: 'No Users Found',
    vendorDetailsError: 'Vendor Details Error',
    deactivateUser: 'Deactivate User',
    doYouWishToDeactivate: 'Do you wish to deactivate',
    asAUser: 'as a user',
    marketplaceFlagged: 'Displayed on Marketplace',
    marketplaceInfoData: {
        pic_validation_message: 'Format JPG / JPEG,  PNG (less than 1MB)',
        website: 'Website',
        description: 'Description',
        readMoreDescription: 'Read More',
        showLessDescription: 'Show Less',
        enterWebsitePlacehodler: 'Enter Website',
        enterDescriptionPlacehodler: 'Enter Description here..',
        feeWaiverDiscount: 'Fee Waiver Discount',
        feeWaiverDiscountInfo:
            'Provides special discounts for Fee Waiver student',
        flagVendorForMarketplace: `When enabled the Vendor's name will be displayed on LSAT Content Licensees`,
        disbled: 'Disbled',
        change: 'Change',
        optional: 'Optional',
        flagMarket: 'Flag Vendor for Marketplace',
        maxlength: 280
    },
    descriptionMaxLength: 100,
    marketplaceFlaggedLabel: 'Marketplace Flagged',
    vendorClientId: 'Vendor Client ID',
    vendorIntegrationClientId: 'Vendor Integration Client ID',
    clientSecret: 'Client Secret',
    clientSecretTimedOutValue: 'Client Secret Timed Out',
    apiAccessEnabledValues: 'Integration, Production ',
    generateSecretCode: 'Generate New Code',
    generateNewIntegrationCode: 'Generate New Integration Code',
    generateNewProductionCode: 'Generate New Production Code',
    enterAppName: 'Enter App Name',
    deleteConfirmation: 'Delete Confirmation!',
    secretCodeDeleteMessage: 'Are you sure to delete secret code ',
    clientSecretDeletedSuccessfully: 'Secret Code Deleted Successfully',
    clientSecretDeleteError: 'Secret Code Delete Error',
    generateSecretError: 'Secret Code Generation Error',
    VendorName: 'Vendor Name:',
    VendorID: 'Vendor ID:',
    VendorType: 'Vendor Type:'
};
export const LAWREADY = {
    lawReady: 'LawReady',
    lawReadyProgram: 'LawReady Program',
    selectAll: 'Select all',
    registeredOnSortKeyName: 'products',
    availableProductsForLawReady: 'Available Product(s): ',
    linkedDate: 'linkedDate',
    productId: 'LSAC-LawReady-Program'
};

export const PLUS_GUIDED_JOURNEY = {
    plusGuidedJourney: 'PlusGuidedJourney',
    productId: 'LSAC-PlusGuidedJourney'
};

export const RouteEnum = {
    SUBSCRIBER: 'SUBSCRIBER',
    LAWREADY: 'LAWREADY',
    DEFAULT: 'DEFAULT'
};

export const PAD = {
    padProgram: 'Phi Alpha Delta',
    tooltipText: 'Product Subscription Expired'
};

export const CLIENT_SECRET = {
    description: 'Description',
    clientSecret: 'Client Secret',
    codeExpiry: 'Code Expiry',
    status: 'Status',
    actions: 'Actions'
};

export const LOGOUT_MODAL = {
    title: "You're about to be logged out",
    message:
        'For your security, this session is about to end due to inactivity.'
};

export const LICENSEE_MARK = {
    registeredMark: '®',
    officialLSATContentLicenseeMarkPrefix: 'Official LSAT',
    officialLSATContentLicenseeMarkSuffix: ' Content Licensee Mark',
    guidelines: 'Guidelines',
    guidelinesDescription1: 'Please review the ',
    officialLicenseeMarkUseGuidelines:
        'Official LSAT® Content Licensee Mark Use Guidelines',
    pdf: '(PDF)',
    guidelinesDescription3:
        ' for detailed information on minimum requirements, as well as permitted and prohibited use cases before downloading assets.',
    checkboxContent1: 'I have read the ',
    checkboxContent2: 'Official LSAT® Content Licensee Mark Use Guidelines ',
    checkboxContent3:
        'and agree to adhere to the requirements set forth therein.',
    downloadButtonText: 'Download Licensee Mark',
    contractNotSignedMessage1:
        'The Official LSAT® Content Licensee Mark is only available to licensees that have executed the most recent version of the Content License Agreement. Based on our records, you have not executed the most recent version of the Content License Agreement.',
    contractNotSignedMessage2:
        'If you have executed the most recent version of the Content License Agreement, please contact ',
    contractNotSignedEmail: 'licensingsupport@lsac.org',
    downloadError: 'Something went wrong while downloading the file.',
    defaultZipFileName: 'licenseemark.zip'
};
